import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { posterService } from "./posterService";

export const getAllPosters = createAsyncThunk('poster/get', async (_, thunkAPI) => {
  try {
    return await posterService.getPosters();
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const posterState = {
  poster: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
}

export const posterSlice = createSlice({
  name: 'poster',
  initialState: posterState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(getAllPosters.pending, (state) => {
      state.isLoading = true;
    })
    .addCase(getAllPosters.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.poster = action.payload; // Ensure action.payload contains the expected data
    })
    .addCase(getAllPosters.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || action.error.message; // Properly handle error messages
    })
      
  }
});

export default posterSlice.reducer;